import { Injectable } from '@angular/core';

import moment from 'moment';

import { DATE_TIME_WITHOUT_TIMEZONE_FORMAT } from 'app/modules/collection/services/filter.service';
import { RelativeDateConstants } from '../constants/constants';
import { TimezoneService } from './timezone.service';

@Injectable({
  providedIn: 'root',
})
export class DateRangeService {
  constructor(private timezoneService: TimezoneService) {}

  public computeRelativeFixedValueForDateFilter(key: string): [string, string] {
    const now = this.timezoneService.now().millisecond(0).endOf('day');

    let valueTo = now.format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
    now.startOf('day');

    switch (key) {
      case RelativeDateConstants.TODAY:
        break;
      case RelativeDateConstants.YESTERDAY:
        now.subtract(1, 'd');
        break;
      case RelativeDateConstants.LAST_7_DAY:
        now.subtract(7, 'd');
        break;
      case RelativeDateConstants.LAST_7_DAY_INCLUDE_TODAY:
        now.subtract(6, 'd');
        break;
      case RelativeDateConstants.PREV_7_DAY:
        now.subtract(14, 'd');
        valueTo = moment(now).add(7, 'd').endOf('d').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
        break;
      case RelativeDateConstants.PREV_7_DAY_INCLUDE_TODAY:
        now.subtract(13, 'd');
        valueTo = moment(now).add(6, 'd').endOf('d').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
        break;
      case RelativeDateConstants.LAST_30_DAY:
        now.subtract(30, 'd');
        break;
      case RelativeDateConstants.LAST_30_DAY_INCLUDE_TODAY:
        now.subtract(29, 'd');
        break;
      case RelativeDateConstants.PREV_30_DAY:
        now.subtract(60, 'd');
        valueTo = moment(now).add(30, 'd').endOf('d').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
        break;
      case RelativeDateConstants.PREV_30_DAY_INCLUDE_TODAY:
        now.subtract(59, 'd');
        valueTo = moment(now).add(29, 'd').endOf('d').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
        break;
      case RelativeDateConstants.MONTH_TO_DATE:
      case RelativeDateConstants.MONTH_TO_DATE_INCLUDE_TODAY:
        now.startOf('month');
        break;
      case RelativeDateConstants.PREV_MONTH:
        now.subtract(1, 'month').startOf('month');
        valueTo = moment(now).endOf('month').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
        break;
      case RelativeDateConstants.PREV_YEAR:
        now.subtract(1, 'year').startOf('year');
        valueTo = moment(now).endOf('year').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
        break;
      case RelativeDateConstants.YEAR_TO_DATE:
      case RelativeDateConstants.YEAR_TO_DATE_INCLUDE_TODAY:
        now.startOf('year');
        break;
    }

    const valueFrom = now.format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
    if (!(key.includes('IT') || key === 'prevM' || key === 'prevY')) {
      valueTo = moment(valueTo).startOf('day').format(DATE_TIME_WITHOUT_TIMEZONE_FORMAT);
    }
    return [valueFrom, valueTo];
  }
}
